import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router";

import { routes } from "./routes";

function useTitleFromRoute() {
  const { pathname } = useLocation();
  useEffect(() => {
    const norm = pathname.replace(/\/$/, "") || "/";
    const route = routes.find((r) => r.path === norm);
    if (route) document.title = route.title;
  }, [pathname]);
}

function useScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "instant" as ScrollBehavior });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
}

export function App() {
  useTitleFromRoute();
  useScrollToHash();

  return (
    <Routes>
      {routes.map(({ path, Component }) => (
        <Route key={path} path={path} element={<Component />} />
      ))}
    </Routes>
  );
}
